
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/invoice-generator",
      function () {
        return require("private-next-pages/invoice-generator.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/invoice-generator"])
      });
    }
  